import { useEffect, useState } from 'react';
import './siteFonts.css';
import LandingPage from './LandingPage';
import GamePage from './WinterLand/GamePage';
import ServicesPage from './ServicesPage';
import CinnamonBunDrop from './CinnamonBunDrop/CinnamonBunDrop';

const getRoute = () => window.location.pathname || '/';

function App() {
  const [route, setRoute] = useState(getRoute());

  useEffect(() => {
    const handleRoute = () => setRoute(getRoute());
    window.addEventListener('popstate', handleRoute);
    return () => {
      window.removeEventListener('popstate', handleRoute);
    };
  }, []);

  const normalizedRoute = route.replace(/\/+$/, '') || '/';
  const resolvedRoute = normalizedRoute === '/game' ? '/winterland' : normalizedRoute;
  const isGame = resolvedRoute === '/winterland';
  const isServices = normalizedRoute === '/services';
  const isCinnamon = normalizedRoute === '/cinnamon-bun-drop';
  const isEmbedWinterland = normalizedRoute === '/embed/winterland';
  const isEmbedCinnamon = normalizedRoute === '/embed/cinnamon-bun-drop';

  useEffect(() => {
    if (normalizedRoute === '/game') {
      window.history.replaceState({}, '', '/winterland');
      setRoute('/winterland');
    }
  }, [normalizedRoute]);

  if (isGame) {
    return <GamePage />;
  }

  if (isServices) {
    return <ServicesPage />;
  }

  if (isCinnamon) {
    return <CinnamonBunDrop />;
  }

  if (isEmbedWinterland) {
    return <GamePage embed />;
  }

  if (isEmbedCinnamon) {
    return <CinnamonBunDrop embed />;
  }

  return <LandingPage />;
}

export default App;
